<template>
  <v-app :style="intraction">
    <WorldSky />
    <div id="cloud"></div>
    <!-- <div id="town" class="background"></div>  -->
    <div id="shrub" class="background background-land"></div>
    <div id="land"></div>
    <div id="road"></div>

    <ApiErrorDialog v-if="apiError && apiError.isError" :api="apiError" />
    <SiteMovedDialog />
    <DebugTool v-if="settings.debug"></DebugTool>
    <Tutorial :intraction.sync="intraction" context="WORLD" />

    <div class="d-flex align-center justify-space-between flex-column" style="height: 100vh; height: 100dvh">
      <div class="signboard" style="z-index: 3">
        <v-img :src="require('@/assets/world/Signboard.png')" class="d-flex align-center justify-center text-center">{{
          currentPlace.translatableTitle[$_getLocale()] }}</v-img>
      </div>
      <!-- Header -->
      <div class="d-flex align-start justify-space-between pa-2" style="width: 100%; z-index: 3">
        <LevelBtn></LevelBtn>
        <Setting></Setting>
      </div>
      <!-- Body -->

      <div class="floting-items">
        <div class="floting-column pt-3">
          <MailBtn />
          <FamilyBtn id="FAMILY_BTN" />
          <SchoolBtn />
        </div>
        <div class="floting-column">
          <WorldCalendar />
          <WorldClock />
          <SubscriptionBtn />
        </div>
      </div>
      <div>
        <transition :name="transitionName">
          <router-view style="z-index: 1" :is-ongoing-event="isOngoingEvent" />
        </transition>
      </div>
      <!-- Footer -->
      <div>
        <WorldNPC ref="npc" id="npc" v-if="
          !(isOngoingEvent && $router.currentRoute.name == 'PageWorldEvents')
        " />

        <WorldStreetPlayers ref="streetPlayers" v-if="isStrangersEnabled" />
        <div class="d-flex flex-column align-center">
          <div id="avatar" :class="[{ 'flip-horizontal': isFlipped }]">
            <AbstractAvatar :avatar="auth.Player.avatar" :height="100" :width="100" class="mx-auto animated-avatar" />
          </div>
          <div class="player-name">
            {{ auth.Student ? auth.Student.name : auth.User.name }}
          </div>
        </div>
        <div class="mb-8 d-flex align-end justify-space-between" style="width: 300px; z-index: 3">
          <v-btn color="yellow" elevation="12" fab small class="mb-12" disabled
            style="z-index: 3"><v-icon>mdi-comment</v-icon></v-btn>
          <v-btn v-if="!canGoPrev" id="arrowLeft" elevation="0" fab style="z-index: 3" :disabled="true">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn v-else id="arrowLeft" color="yellow" elevation="12" fab class="btn-3d" style="z-index: 3"
            @click="prevPlace"><v-icon>mdi-chevron-left</v-icon></v-btn>
          <v-btn color="yellow" elevation="12" fab class="btn-3d" style="z-index: 3" @click="home"
            id="buttonHome"><v-icon>mdi-magnify</v-icon></v-btn>
          <v-btn v-if="!canGoNext" id="arrowRight" elevation="0" fab style="z-index: 3" :disabled="true">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn v-else id="arrowRight" color="yellow" elevation="12" fab class="btn-3d" style="z-index: 3"
            @click="nextPlace"><v-icon>mdi-chevron-right</v-icon></v-btn>
          <v-btn color="yellow" elevation="12" fab small class="mb-12" disabled
            style="z-index: 3"><v-icon>mdi-emoticon</v-icon></v-btn>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    Setting: () => ({
      component: import(
        /* webpackChunkName: "component-setting" */ "@/components/Setting"
      ),
    }),
    Tutorial: () => ({
      component: import(
        /* webpackChunkName: "component-tutorial" */ "@/components/Tutorial"
      ),
    }),
    AbstractAvatar: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
    }),
    SubscriptionBtn: () =>
      import(
        /* webpackChunkName: "component-subscription-btn" */ "@/components/SubscriptionBtn"
      ),
    MailBtn: () =>
      import(
        /* webpackChunkName: "component-mail-btn" */ "@/components/MailBtn"
      ),
    FamilyBtn: () =>
      import(
        /* webpackChunkName: "component-family-btn" */ "@/components/FamilyBtn"
      ),
    LevelBtn: () =>
      import(
        /* webpackChunkName: "component-level-btn" */ "@/components/LevelBtn"
      ),
    SchoolBtn: () =>
      import(
        /* webpackChunkName: "component-school-btn" */ "@/components/SchoolBtn"
      ),
    WorldSky: () =>
      import(
        /* webpackChunkName: "component-world-sky" */ "@/components/world/WorldSky"
      ),
    WorldCalendar: () =>
      import(
        /* webpackChunkName: "component-world-calendar" */ "@/components/world/WorldCalendar"
      ),
    WorldClock: () =>
      import(
        /* webpackChunkName: "component-world-clock" */ "@/components/world/WorldClock"
      ),
    WorldNPC: () =>
      import(
        /* webpackChunkName: "component-world-npc" */ "@/components/world/WorldNPC"
      ),
    WorldStreetPlayers: () =>
      import(
        /* webpackChunkName: "component-world-street-players" */ "@/components/world/WorldStreetPlayers"
      ),
    DebugTool: () =>
      import(
        /* webpackChunkName: "component-debug-tool" */ "@/components/DebugTool"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    SiteMovedDialog: () =>
      import(
        /* webpackChunkName: "component-site-moved-dialog" */ "@/components/SiteMovedDialog"
      ),
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      settings: (state) => state.settings.data,
      coin: (state) => state.coin.data,
    }),
    canGoPrev() {
      const currentIndex = this.places.findIndex(
        (place) => place.routeName === this.$route.name
      );
      return currentIndex > 0;
    },
    canGoNext() {
      const currentIndex = this.places.findIndex(
        (place) => place.routeName === this.$route.name
      );
      return currentIndex < this.places.length - 1;
    },
  },
  props: [
    //
  ],
  data: () => ({
    intraction: null,
    currentPlace: {},
    isFlipped: false,
    places: [
      {
        name: "Events",
        routeName: "PageWorldEvents",
        translatableTitle: { en: "Events", ms: "Acara", zh: "活动" },
      },
      {
        name: "News",
        routeName: "PageWorldNews",
        translatableTitle: { en: "News", ms: "Berita", zh: "新闻" },
      },
      {
        name: "Play with Friend",
        routeName: "PageWorldFun",
        translatableTitle: {
          en: "Play with Friends",
          ms: "Main dengan Rakan",
          zh: "和朋友一起玩",
        },
      },
      {
        name: "???",
        routeName: "PageWorldPortal",
        translatableTitle: { en: "???", ms: "???", zh: "???" },
      },
      {
        name: "Math",
        routeName: "PageWorldMath",
        translatableTitle: { en: "Math", ms: "Matematik", zh: "数学" },
      },
      {
        name: "ABC",
        routeName: "PageWorldABC",
        translatableTitle: { en: "ABC", ms: "ABC", zh: "ABC" },
      },
    ],
    transitionName: "slide-left",
    isEnoughCoin: false,
    isOngoingEvent: false,
    apiError: null,
    eventsApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    coinApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    platformApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    pinCheckerApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    isStrangersEnabled: false
  }),
  async created() {
    this.currentPlace = this.places.find(
      (place) => place.routeName === this.$route.name
    );
    await this.checkPin()
    await this.loadEvents();
    // await this.loadCoins();
    await this.readPlatform()
  },
  mounted() {
    //
  },
  methods: {
    nextPlace() {
      this.$intro().exit();
      const currentIndex = this.places.findIndex(
        (place) => place.routeName === this.$route.name
      );
      const nextIndex = currentIndex + 1;

      if (nextIndex < this.places.length) {
        this.$refs.npc?.remove();
        this.$refs.streetPlayers?.removePlayers();
        const nextPlace = this.places[nextIndex];
        this.isFlipped = false;
        this.transitionName = "slide-left";
        this.$router.push({ name: nextPlace.routeName });
        this.currentPlace = nextPlace;
        this.$refs.npc?.randomize();
        // this.$refs.streetPlayers?.loadPlayers();
      }
    },
    prevPlace() {
      this.$intro().exit();
      const currentIndex = this.places.findIndex(
        (place) => place.routeName === this.$route.name
      );
      const prevIndex = currentIndex - 1;

      if (prevIndex >= 0) {
        this.$refs.npc?.remove();
        this.$refs.streetPlayers?.removePlayers();
        const prevPlace = this.places[prevIndex];
        this.isFlipped = true;
        this.transitionName = "slide-right";
        this.$router.push({ name: prevPlace.routeName });
        this.currentPlace = prevPlace;
        this.$refs.npc?.randomize();
        // this.$refs.streetPlayers?.loadPlayers();
      }
    },

    home() {
      this.$intro().exit();
      this.$router.push({
        name: "PageExploreMenu",
      });
    },

    async loadEvents() {
      this.eventsApi.method = "GET";
      this.eventsApi.url =
        this.$api.servers.event +
        "/api/v2/" +
        this.$_getLocale() +
        "/game/event";

      this.eventsApi.callbackReset = () => {
        this.eventsApi.isLoading = true;
        this.eventsApi.isError = false;
      };

      this.eventsApi.callbackError = (e) => {
        this.eventsApi.isLoading = false;
        this.eventsApi.isError = true;
        this.eventsApi.error = e;
        this.apiError = this.eventsApi;
      };
      this.eventsApi.callbackSuccess = (resp) => {
        this.isOngoingEvent = resp.data.ongoing && resp.data.ongoing.length > 0;
      };
      await this.$api.fetch(this.eventsApi);
    },
    async loadCoins() {
      this.coinApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/inventory";
      this.coinApi.callbackReset = () => {
        this.coinApi.isLoading = true;
        this.coinApi.isError = false;
        this.coinApi.error = null;
      };
      this.coinApi.callbackError = (e) => {
        this.coinApi.isLoading = false;
        this.coinApi.isError = true;
        this.coinApi.error = e;
        this.apiError = this.coinApi;
      };
      this.coinApi.callbackSuccess = (resp) => {
        this.coinApi.isLoading = false;
        var coins = null;
        coins = resp.filter(function (entry) {
          return entry.Item.key == "goldcoin";
        });
        var goldenbrush = null;
        goldenbrush = resp.filter(function (entry) {
          return entry.Item.key == "goldenbrush";
        });
        if (goldenbrush[0]) {
          this.goldenbrush = goldenbrush[0].Inventory.quantity;
        } else {
          this.goldenbrush = 0;
        }
        if (coins[0]) {
          this.coins = coins[0].Inventory.quantity;
        } else {
          this.coins = 0;
        }
        this.$store.commit("updateCoin", {
          Goldenbrush: { quantity: this.goldenbrush },
          Currency: { quantity: this.coins },
        });
        this.isEnoughCoin = this.coins > 0;
      };
      await this.$api.fetch(this.coinApi);
    },
    async readPlatform() {
      this.platformApi.url =
        this.$api.servers.log +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/platform/read";
      this.platformApi.callbackReset = () => {
        this.platformApi.isLoading = true;
        this.platformApi.isError = false;
        this.platformApi.error = null;
      };
      this.platformApi.callbackError = (e) => {
        this.platformApi.isLoading = false;
        this.platformApi.isError = true;
        this.platformApi.error = e;
        this.apiError = this.platformApi;
      };
      this.platformApi.callbackSuccess = async (resp) => {
        this.platformApi.isLoading = false;
        this.isStrangersEnabled = resp.value?.isEnable
      };
      this.platformApi.params = {
        key: "STRANGERS"
      };
      await this.$api.fetch(this.platformApi);
    },
    async checkPin() {
      this.pinCheckerApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/player/checkPinUpdate";

      this.pinCheckerApi.callbackReset = () => {
        this.pinCheckerApi.isLoading = true;
        this.pinCheckerApi.isError = false;
      };

      this.pinCheckerApi.callbackError = (e) => {
        this.pinCheckerApi.isLoading = false;
        this.pinCheckerApi.isError = true;
        this.pinCheckerApi.error = e;
        this.apiError = this.pinCheckerApi;
      };

      this.pinCheckerApi.callbackSuccess = (resp) => {
        this.pinCheckerApi.isLoading = false;
        if (resp.shouldLogout) {
          let authData = this.$_.cloneDeep(this.auth);
          authData.Session = undefined;
          this.$store.commit("updateAuth", authData);
          this.$router.push({ name: "PageErrorPinChanged" });
        }
      };
      await this.$api.fetch(this.pinCheckerApi);
    }
  },
};
</script>

<style scoped>
#town {
  background-image: url("../assets/world/BackgroundTownWithoutSky.png");
  background-position: bottom;
  background-size: 1920px 1080px;
}

#shrub {
  background-image: url("../assets/world/bgs/DraftWorldShrub.png");
  background-size: auto !important;
  background-position: center calc(100vh - 240px - 140px) !important;
  background-position: center calc(100dvh - 240px - 140px) !important;
}

#road {
  /* background-image: url("../assets/world/bgs/WorldRoadDirt.png"); */
  background-image: url("../assets/world/bgs/DraftWorldRoadStone.png");
  /* background-size: auto 140px !important;
  background-position: center calc(100% - 100px) !important; */
  position: fixed;
  background-color: #f9e79f;
  /* fallback color */
  background-repeat: repeat-x;
  background-size: auto;
  background-position: bottom;
  bottom: 100px;
  height: 140px;
  width: 100vw;
  /* fallback width */
  width: 100dvw;
  z-index: 0;
  border-top: solid 3px #fff5ce;
  border-bottom: solid 6px #dac679;
}

#land {
  /* background-image: url("../assets/world/bgs/DraftWorldGrassBack.png"); */

  background-image: url("../assets/world/bgs/DraftWorldGrassResized.png");
  background-size: auto;
  background-repeat: repeat;

  /* background-color: #685815; */
  position: fixed;
  height: 240px;
  width: 100vw;
  /* fallback width */
  width: 100dvw;
  bottom: 0;
  z-index: 0;
}

.background-land {
  background-position: bottom;
  background-size: auto 1080px;
}

@media (max-width: 1920px) {
  .background-land {
    background-size: 1920px 1080px;
  }
}

.background {
  background-repeat: no-repeat;
  position: fixed;
  /* width: 960px;
  height: 540px; */
  min-width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  z-index: 0;
}

.signboard {
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
}

#npc {
  position: fixed;
  bottom: 180px;
  z-index: 3;
}

#btn-subscription {
  position: fixed;
  right: 10px;
  top: 184px;
  z-index: 10;
}

#avatar {
  z-index: 3;
}

.animated-avatar {
  animation: idle 2s infinite alternate ease-in-out;
  transform-origin: center calc(100% - 5px);
}

@keyframes idle {
  0% {
    transform: scale(1, 1);
    /* Original size */
  }

  100% {
    transform: scale(1, 1.05);
    /* Slightly stretched */
  }
}

.map-marker {
  width: 60px;
  height: 60px;
  background-color: #ffeb3b;
  /* Vuetify yellow */
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  cursor: pointer;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.map-marker-icon {
  transform: rotate(45deg);
  /* undo parent rotation so icon looks upright */
}

.player-name {
  z-index: 4 !important;
}

.btn-3d {
  background: linear-gradient(to top, #f1c40f, #f9e79f);
  /* Yellow gradient */
  border: none;
  color: #333;
  font-weight: bold;
  font-size: 16px;
  padding: 16px 24px;
  border-radius: 50%;
  box-shadow: inset 0 4px 8px rgba(255, 255, 255, 0.6),
    /* Inner highlight */
    0 6px 12px rgba(0, 0, 0, 0.3);
  /* Outer shadow for 3D effect */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.btn-3d:hover {
  box-shadow: inset 0 2px 4px rgba(255, 255, 255, 0.6),
    0 4px 8px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px);
  /* subtle lift */
}

.btn-3d:active {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.2);
  transform: translateY(1px);
  /* pressed in */
}

.floting-items {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  z-index: 5;
  top: 60px;
  left: 0;
  padding: 10px;
  pointer-events: none;
}

.floting-column * {
  pointer-events: auto;
}

.floting-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Slide Left (Next) */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.5s ease-in-out, opacity 0.5s;
  position: fixed !important;
  bottom: 0px !important;
}

.slide-left-enter {
  transform: translateX(100vw);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-100vw);
  opacity: 0;
}

/* Slide Right (Previous) */
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.5s ease-in-out, opacity 0.5s;
  position: fixed !important;
  bottom: 0px !important;
}

.slide-right-enter {
  transform: translateX(-100vw);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(100vw);
  opacity: 0;
}

.flip-horizontal {
  transform: scaleX(-1);
}
</style>